import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getReview, saveReview } from "../../util/ApiService";
import "./AddReviews.css";

const AddReviews = ({ product }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const res = await getReview(1);
      setReviews(res.data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
    setLoading(false);
  };

  const onSubmit = async (data) => {
    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("rating", data.rating);
      formData.append("comment", data.comment);
      if (data.image?.[0]) {
        formData.append("image", data.image[0]);
      }
      await saveReview(formData);
      reset();
      fetchReviews();
    } catch (error) {
      console.error("Error submitting review:", error);
    }
    setSubmitting(false);
  };

  return (
    <div className="review-container">
      <div className="review-form">
        <h2>Write a Review</h2>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <input
            {...register("name", { required: true })}
            placeholder="Your Name"
          />
          {errors.name && <p className="error-text">Name is required</p>}

          <input
            type="number"
            min="1"
            max="5"
            {...register("rating", { required: true, min: 1, max: 5 })}
            placeholder="Rating (1-5)"
          />
          {errors.rating && (
            <p className="error-text">Rating must be between 1 and 5</p>
          )}

          <textarea
            {...register("comment", { required: true })}
            placeholder="Your Comment"
          />
          {errors.comment && <p className="error-text">Comment is required</p>}

          <input type="file" accept="image/*" {...register("image")} />

          <button type="submit" disabled={submitting} className="btn-submit">
            {submitting ? "Submitting..." : "Submit Review"}
          </button>
        </form>
      </div>
      {reviews.length > 0 && (
        <div className="review-list">
          <h3>Customer Reviews</h3>
          {reviews.map((rev) => (
            <div key={rev.id} className="review-card">
              <strong>{rev.name}</strong>
              <div className="rating">Rating: {rev.rating}/5</div>
              <p>{rev.comment}</p>
              {rev.image_url && (
                <img
                  src={rev.image_url}
                  alt="Review"
                  className="review-image"
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddReviews;
